import React, { useState, useRef, useEffect, Suspense } from 'react'
import PickerIcon from '@bufferapp/ui/Icon/Icons/More'

import { Loader } from '~/shared/components'

import {
  Wrapper,
  List,
  ListItem,
  Emoji,
  IconWrapper,
  PickerWrapper,
  PICKER_HEIGHT,
  PICKER_MARGIN,
} from './styles'

const EmojiPicker = React.lazy(
  () =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    import(/* webpackChunkName: "emoji-picker" */ '../EmojiPicker'),
)

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'emojis' implicitly has an 'any' t... Remove this comment to see the full error message
const EmojiSelector = ({ emojis, onSelection }) => {
  const [pickerOpened, setPickerOpened] = useState(false)
  const [position, setPosition] = useState(null)

  const pickerToggleRef = useRef(null)
  const pickerRef = useRef(null)

  useEffect(() => {
    if (pickerOpened) {
      document.addEventListener('click', onClosePicker, true)
    } else {
      document.removeEventListener('click', onClosePicker, true)
    }
  }, [pickerOpened])

  const getPickerPosition = () => {
    const commentList = document.getElementById('comments-list')
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const commentListRect = commentList.getBoundingClientRect()
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const pickerToggleRect = pickerToggleRef.current.getBoundingClientRect()

    const margin = PICKER_MARGIN * 2
    const areaTop = pickerToggleRect.y - commentListRect.y - margin
    const areaBottom = commentListRect.bottom - pickerToggleRect.bottom - margin

    return areaBottom >= PICKER_HEIGHT || areaBottom >= areaTop
      ? { direction: 'bottom', maxHeight: areaBottom }
      : { direction: 'top', maxHeight: areaTop }
  }

  // @ts-expect-error TS(7031) FIXME: Binding element 'target' implicitly has an 'any' t... Remove this comment to see the full error message
  const onClosePicker = ({ target }) => {
    if (!pickerOpened || !pickerRef.current) {
      return null
    }

    // @ts-expect-error TS(2339) FIXME: Property 'contains' does not exist on type 'never'... Remove this comment to see the full error message
    const clickedOutside = !pickerRef.current.contains(target)
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const clickedOnToggle = pickerToggleRef.current.contains(target)

    if (clickedOutside && !clickedOnToggle) {
      setPickerOpened(false)
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onTogglePicker = (event) => {
    event.stopPropagation()
    setPickerOpened(!pickerOpened)

    const pickerPosition = getPickerPosition()
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ direction: string; maxHeight: ... Remove this comment to see the full error message
    setPosition(pickerPosition)
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onPickEmoji = (event) => {
    const codes = event.unified.split('-')
    // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
    const fullCodes = codes.map((el) => '0x' + el)
    const emoji = String.fromCodePoint(...fullCodes)
    onSelection(emoji)
    setPickerOpened(false)
  }

  return (
    <Wrapper>
      <List>
        {/* @ts-expect-error TS(7006) FIXME: Parameter 'emoji' implicitly has an 'any' type. */}
        {emojis.map((emoji, index) => (
          <ListItem
            key={index}
            role="button"
            onClick={() => onSelection(emoji)}
          >
            <Emoji>{emoji}</Emoji>
          </ListItem>
        ))}
        <ListItem
          // @ts-expect-error TS(2769) FIXME: No overload matches this call.
          selected={pickerOpened}
          onClick={onTogglePicker}
          ref={pickerToggleRef}
        >
          <IconWrapper>
            <PickerIcon />
          </IconWrapper>
        </ListItem>
      </List>
      {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
      <PickerWrapper visible={pickerOpened} position={position} ref={pickerRef}>
        <Suspense fallback={<Loader />}>
          <EmojiPicker onSelect={onPickEmoji} />
        </Suspense>
      </PickerWrapper>
    </Wrapper>
  )
}

export default EmojiSelector
